import { Link } from "@mui/material";

import defaultStyles from "./styles";

interface Props {
  styles?: any;
  href: string;
  [rest: string]: any;
}

export default function StyledLink({
  children,
  href,
  styles = {},
  ...rest
}: Props) {
  return (
    <Link
      target="_blank"
      rel="noreferrer"
      href={href}
      sx={[defaultStyles.link, styles]}
      {...rest}
    >
      {children}
    </Link>
  );
}
